import {
  MDBContainer,
} from 'mdbreact';
import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component, useState, useEffect
} from 'react';
import {
  translate,
} from 'helperFunctions/translation';
import {
  IFacilityStore
} from 'mobx-store/storeInterfaces/facilitiesInterface';

import { GeneralChartComponent } from 'components/GeneralCharts';
import { ChartTypes } from 'components/GeneralCharts/types';
import { DatePicker } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { Button } from '@material-ui/core';
import SnackBarComponent from 'components/SnackBarComponent/SnackBarComponent';

import classes from './style.module.scss';

interface FacilityStatisticsProps {
  history?: any;
  match: any;
  facilityStore: IFacilityStore;
}

// functional component
const FacilityStatistics: React.FC<FacilityStatisticsProps> = observer(inject('facilityStore')((props) => {

  // Props
  const {
    history,
    facilityStore,
    match
  } = props;

  // States
  const [from, setFrom]: MaterialUiPickersDate | any = useState(null);
  const [to, setTo]: MaterialUiPickersDate | any = useState(null);
  const [facilityId, setBranchId] = useState(match.params.facilityId);
  const [facilityData , setFacilityData] = useState({});

  const changeChartState = async () => {
    setFacilityData({
          labels: facilityStore?.facilityStatistics.labels ,
          datasets: [
          {
            label: 'Facilities Rating',
            fill: false,
            type: 'line',
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: facilityStore?.facilityStatistics.points
          }
        ]
    });
  };

const onInit = async () => {
  await facilityStore.getFacilityRatingStatistics(+facilityId);
  await changeChartState();
};

const handleFromChanged = async (date: MaterialUiPickersDate) => {
  setFrom(date);
  await changeChartState();
};

const handleToChanged =  async (date: MaterialUiPickersDate) => {
  setTo(date);
  await changeChartState();
};

const filter = async () => {
  try {
    if (!from || !to) {
        SnackBarComponent.getInstance().openSnackbar(
          'Start date and end date are required',
          3000,
          'error'
        );
        return ;
    }
    await facilityStore.getFacilityRatingStatistics(
      +facilityId ,
      `${from?.c.month}-${from!.c.day}-${from!.c.year}`,
      `${to!.c.month}-${to!.c.day}-${to!.c.year}`
      );
      setFacilityData({});
      await changeChartState();
  } catch (error) {
    SnackBarComponent.getInstance().openSnackbar(
      'Error while Filtering',
      3000,
      'error'
    );
  }
};

const clearFilter = async () => {
  setFacilityData({});
  setFrom(null);
  setTo(null);
  onInit();
};

useEffect (() => {
  onInit();
}, []);

return (
    <div>
      <MDBContainer>
        <h3 className='mt-5'>
          {translate('STATISTICS_FACILITY', {
          })}
        </h3>
        <div className={classes.datePickerContainer}>
          <div>
          <DatePicker
          variant='inline'
          format='MM/dd/yyyy'
          label='From'
          value={from}
          onChange={(value) => {
            handleFromChanged(value);
          }}
        />
        <DatePicker
          variant='inline'
          format='MM/dd/yyyy'
          label='To'
          value={to}
          onChange={(value) => {
            handleToChanged(value);
          }}
        />
          </div>
          <div>
          <Button onClick={clearFilter}   color='primary'  variant='contained'>Clear</Button>
          <Button onClick={filter}   color='primary'  variant='contained'>Filter</Button>
          </div>
        </div>
        <GeneralChartComponent type={ChartTypes.LINE} data={facilityData} />
      </MDBContainer>
    </div>
);

}));

export default FacilityStatistics;
